<style>

</style>
<template>
  <div
    style="width: 100vw;
            height: 100vh;
            padding: 0px !important;
            margin: 0px !important;
            top: 62px !important;
            left: 0px !important;
            position: absolute;"
    :dir="$functions.currentLangDirection()"
  >
    <div
      class="card  d-md-block"
      style="overflow-x: hidden;margin: 8px;overflow-y: scroll;height: 90vh;display: block;"
    >
      <b-card-body style="background: #fff;margin: 5px;">
        <!-- نمایش اطلاعات دستگاه -->
        <b-row
          v-if="deviceInfo && deviceInfo.imei"
          :dir="$functions.currentLangDirection()"
        >
          <b-col
            cols="12"
          >
            {{ deviceInfo.title }}
          </b-col>
          <b-col
            cols="12"
          >
            {{ deviceInfo.imei }}
          </b-col>
        </b-row>

        <!-- پیام لودینگ -->
        <b-row
          v-else
          :dir="$functions.currentLangDirection()"
        >
          <b-col
            cols="12"
            style="text-align: center; padding: 20px;"
          >
            <p>در حال بارگذاری اطلاعات دستگاه...</p>
          </b-col>
        </b-row>
      </b-card-body>

      <v-tabs
        vertical
        class="commandTabs"
        :dir="$functions.currentLangDirection()"
      >
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-car-brake-alert
          </v-icon>
          {{ $t('Emergency number') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-vibrate
          </v-icon>
          {{ $t('Vibrating alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-account-tie
          </v-icon>
          {{ $t('Center number') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-power-plug-off
          </v-icon>
          {{ $t('Power outage') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-power-plug
          </v-icon>
          {{ $t('Plug in') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-power
          </v-icon>
          {{ $t('Power failure alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-battery-alert-variant-outline
          </v-icon>
          {{ $t('Battery alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-car-electric
          </v-icon>
          {{ $t('Switch alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-car-emergency
          </v-icon>
          {{ $t('Displacement alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-car-speed-limiter
          </v-icon>
          {{ $t('Speed alarm') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-server-network
          </v-icon>
          {{ $t('Server settings') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-restart
          </v-icon>
          {{ $t('Restart') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-console-line
          </v-icon>
          {{ $t('Custom Command') }}
        </v-tab>
        <v-tab>
          <v-icon
            size="18"
            left
          >
            mdi-history
          </v-icon>
          تاریخچه درخواست‌ها
        </v-tab>

        <!-- Emergency Numbers Tab -->
        <v-tab-item>
          <EmergencyNumberSettings
            v-if="deviceInfo && deviceInfo.imei && selectedImei"
            :selected-imei="selectedImei"
            :device-info="deviceInfo"
            @command-sent="onCommandSent"
          />
          <div
            v-else
            class="loading-container"
            style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری اطلاعات دستگاه...
            </p>
            <p style="font-size: 12px; color: #666;">
              IMEI: {{ selectedImei || 'در حال شناسایی...' }}
            </p>
          </div>
        </v-tab-item>

        <!-- Vibration Alert Tab -->
        <v-tab-item>
          <VibrationAlertSettings
            v-if="deviceInfo && deviceInfo.imei && selectedImei"
            :selected-imei="selectedImei"
            :device-info="deviceInfo"
            @command-sent="onCommandSent"
          />
          <div
            v-else
            class="loading-container"
            style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری اطلاعات دستگاه...
            </p>
          </div>
        </v-tab-item>

        <!-- Center Number Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>

              <v-radio-group
                v-model="adminval"
                row
              >
                <v-radio
                  :label="$t('Settings')"
                  value="adminSet"
                />
                <v-radio
                  :label="$t('Remove admin number')"
                  value="adminDel"
                />
              </v-radio-group>
              <div v-if="adminval==='adminSet'">
                <p>{{ $t('Text-2') }}</p>
                <b-form-group
                  :label="$t('Mobile')"
                  label-for="v-phone"
                >
                  <b-form-input
                    v-model="phone"
                    style="text-align: left;"
                  />
                </b-form-group>
                <b-button
                  size="sm"
                  variant="success"
                  @click="onSendCommand(selectedImei, 'CENTER,A,'+phone+'#')/*SendSms('CENTER,A,'+phone+'#')*/"
                >
                  {{ $t('Send SMS') }}
                </b-button>
              </div>
              <div v-else>
                <b-button
                  size="sm"
                  variant="success"
                  @click="onSendCommand(selectedImei, 'CENTER,D#')/*SendSms('CENTER,D,#')*/"
                >
                  {{ $t('Send SMS') }}
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power Off Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <p>{{ $t('Text-3') }}</p>
                <b-button
                  style="background: #c72828 !important;border-radius: 10px;border: 1px solid #fff !important;"
                  class="btn btn-light btn-sm"
                  :disabled="powerBtnDisabled(selectedImei, 'powerOff')"
                  @click="onSendCommand(selectedImei, 'powerOff')"
                >
                  <v-icon
                    size="20"
                    color="#fff"
                  >mdi-power-plug-off</v-icon>
                  <span style="">{{ $t('Power outage') }}</span>
                </b-button>
                <power-command-status
                  :imei="selectedImei"
                  :state="powerCmd"
                  :relay="relayInfo(selectedImei)"
                  :elapsed="powerCmdElapsed()"
                  class="mt-1"
                  @dismiss="dismissPowerCmd"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power On Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <p>{{ $t('Text-4') }}</p>
                <b-button
                  style="background: #28c76a !important;border-radius: 10px;border: 1px solid #fff !important;"
                  class="btn btn-light btn-sm"
                  :disabled="powerBtnDisabled(selectedImei, 'powerOn')"
                  @click="onSendCommand(selectedImei, 'powerOn')"
                >
                  <v-icon
                    size="20"
                    color="#fff"
                  >mdi-power-plug</v-icon>
                  <span style="">{{ $t('Plug in') }}</span>
                </b-button>
                <power-command-status
                  :imei="selectedImei"
                  :state="powerCmd"
                  :relay="relayInfo(selectedImei)"
                  :elapsed="powerCmdElapsed()"
                  class="mt-1"
                  @dismiss="dismissPowerCmd"
                />
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Power Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                  v-model="MODE_POWERALM"
                  :items="itemsSENALM"
                  item-text="name"
                  item-value="value"
                  :label="$t('Send alerts via')"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                  variant="gradient-warning"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'POWERALM,ON,'+MODE_POWERALM+',5,300#')/*SendSms('POWERALM,ON,1,5,300#')*/"
                >
                  <span style="">{{ $t('Turn on the power failure alarm') }}</span>
                </b-button>
                <br><br>
                <b-button
                  variant="gradient-primary"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'POWERALM,OFF#')/*SendSms('POWERALM,OFF#')*/"
                >
                  <span style="">{{ $t('Turn off the power failure alarm') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Battery Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                  v-model="MODE_ALM"
                  :items="itemsSENALM"
                  item-text="name"
                  item-value="value"
                  :label="$t('Send alerts via')"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                  variant="gradient-warning"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'BATALM,ON,' + MODE_ALM + '#')/*SendSms('BATALM,ON,1#')*/"
                >
                  <span style="">{{ $t('Turn on the battery alarm') }}</span>
                </b-button>
                <br><br>
                <b-button
                  variant="gradient-primary"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'BATALM,OFF#')/*SendSms('BATALM,OFF#')*/"
                >
                  <span style="">{{ $t('Turn off the battery alarm') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Switch Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <v-select
                  v-model="MODE_ACCALM"
                  :items="itemsSENALM"
                  item-text="name"
                  item-value="value"
                  :label="$t('Send alerts via')"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                  variant="gradient-warning"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'ACCALM,ON,'+MODE_ACCALM+',10,0#')/*SendSms('ACCALM,ON#')*/"
                >
                  <span style="">{{ $t('Turn on the warning switch') }}</span>
                </b-button>
                <br><br>
                <b-button
                  variant="gradient-primary"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'ACCALM,OFF#')/*SendSms('ACCALM,OFF#')*/"
                >
                  <span style="">{{ $t('Turn off the warning switch') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Movement Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">

                <b-form-group
                  :label="$t('radius of movement (m)')"
                >
                  <b-form-input
                    v-model="limitmetr"
                    style="text-align: left;"
                  />
                </b-form-group>
                <v-select
                  v-model="MODE_MOVING"
                  :items="itemsNOtF"
                  item-text="name"
                  item-value="value"
                  :label="$t('Send alerts via')"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                  variant="gradient-warning"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'MOVING,ON,'+limitmetr+','+MODE_MOVING+'#') /*SendSms('MOVING,ON,'+limitmetr+',1#')*/"
                >
                  <span style="">{{ $t('Turn on displacement alarm') }}</span>
                </b-button>
                <br><br>
                <b-button
                  variant="gradient-primary"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'MOVING,OFF#')/*SSendSms('MOVING,OFF#')*/"
                >
                  <span style="">{{ $t('Turn off displacement alarm') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Speed Alert Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-form-group
                  :label="$t('Maximum allowed speed')"
                >
                  <b-form-input
                    v-model="limitspeed"
                    style="text-align: left;"
                  />
                </b-form-group>
                <b-form-group
                  :label="$t('Alarm interval(sec)')"
                >
                  <b-form-input
                    v-model="limitspeedtime"
                    style="text-align: left;"
                  />
                </b-form-group>
                <v-select
                  v-model="MODE_speed"
                  :items="itemsNOtF"
                  item-text="name"
                  item-value="value"
                  :label="$t('Send alerts via')"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                />
                <b-button
                  variant="gradient-warning"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'SPEED,ON,'+limitspeedtime+','+limitspeed+','+MODE_speed+'#')/*SendSms('SPEED,ON,'+limitspeedtime+','+limitspeed+',1#')*/"
                >
                  <span style="">{{ $t('Turn on the speed alarm') }}</span>
                </b-button>
                <br><br>
                <b-button
                  variant="gradient-primary"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'SPEED,OFF#')/*SendSms('SPEED,OFF#')*/"
                >
                  <span style="">{{ $t('Turn off the speed alarm') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Server Settings Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-button
                  variant="gradient-info"
                  class="btn-sm"
                  @click="SendSms('SERVER,1,s1.payandservice.ir,4000,0#')"
                >
                  <span style="">{{ $t('Send') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Restart Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <div style="text-align: center;">
                <b-button
                  variant="gradient-info"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, 'RESET#')/*SendSms('RESET#')*/"
                >
                  <span style="">{{ $t('Restart') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Custom Command Tab -->
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <p>{{ $t('Text-15') }}</p>
              <b-form-group>
                <b-form-input
                  v-model="textCustom"
                  style="text-align: left;"
                />
              </b-form-group>
              <div style="text-align: center;">
                <b-button
                  variant="gradient-info"
                  class="btn-sm"
                  @click="onSendCommand(selectedImei, textCustom)/*SendSms('RESET#')*/"
                >
                  <span style="">{{ $t('Send') }}</span>
                </b-button>
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <!-- Command History Tab -->
        <v-tab-item>
          <CommandHistory
            v-if="deviceInfo && deviceInfo.imei && selectedImei"
            :selected-imei="selectedImei"
            :device-info="deviceInfo"
          />
          <div
            v-else
            class="loading-container"
            style="text-align: center; padding: 40px;"
          >
            <p style="margin-top: 16px;">
              در حال بارگذاری تاریخچه...
            </p>
          </div>
        </v-tab-item>

      </v-tabs>
    </div>

  </div>
</template>

<script>
import {
  BLink, BButton, BCard, BCardText, BCardBody, BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import Vue from 'vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { getUserData } from '@/auth/utils'
import EmergencyNumberSettings from '@/views/Home/EmergencyNumberSettings.vue'
import VibrationAlertSettings from '@/views/Home/VibrationAlertSettings.vue'
import CommandHistory from '@/views/Home/CommandHistory.vue'

import deviceCommand from '@/mixins/deviceCommand'
import PowerCommandStatus from '@/components/device-command/PowerCommandStatus.vue'

export default {
  components: {
    PowerCommandStatus,
    EmergencyNumberSettings,
    VibrationAlertSettings,
    CommandHistory,
    BLink,
    BButton,
    BCard,
    BCardText,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
  },
  mixins: [deviceCommand],
  data() {
    return {
      address: '',
      sortBy: 'creationTime',
      selectedImei: Vue.prototype.$selectCommand,
      deviceInfo: {},
      imei: getUserData().imei,
      phone: getUserData().mobile,
      phone2: '',
      phone3: '',
      phone4: '',
      textCustom: '',
      sosval: 'sosSet',
      adminval: 'adminSet',
      limitspeed: 100,
      limitspeedtime: 20,
      limitmetr: 100,
      itemslevel: ['1', '2', '3', '4', '5'],
      selectlevel: '1',
      itemsNOtF: [{ name: 'اپلیکشن', value: '0' }, { name: 'پیامک و اپلیکیشن', value: '1' }],
      MODE_ALM: '1',
      itemsSENALM: [{ name: 'اپلیکشن', value: '0' }, { name: 'پیامک و اپلیکیشن', value: '1' }, { name: 'پیامک و اپلیکیشن و تماس', value: '2' }],
      MODE_SENALM: '1',
      MODE_speed: '1',
      MODE_MOVING: '1',
      MODE_POWERALM: '1',
      MODE_ACCALM: '1',
    }
  },
  computed: {

  },
  created() {
    this.deviceInfo = Vue.prototype.$functions.getDeviceInfo(Vue.prototype.$selectCommand)
  },
  updated() {
    this.deviceInfo = Vue.prototype.$functions.getDeviceInfo(Vue.prototype.$selectCommand)
  },
  mounted() {
    this.deviceInfo = Vue.prototype.$functions.getDeviceInfo(Vue.prototype.$selectCommand)
    this.loadDetail()
  },
  methods: {
    onCommandSent(data) {
      // console.log('📤 دستور ارسال شد:', data)
    },
    SendSms(txt) {
      if (Vue.prototype.$productionPlatform === 'ios') {
        window.location.href = `sms://${this.deviceInfo.sim}&body=${encodeURIComponent(txt)}`
      } else if (Vue.prototype.$productionPlatform === 'android') {
        // window.location.href = `http://127.0.0.1:3232/QXNative/?action=openSmsManager&to=${this.deviceInfo.sim}&body=${encodeURIComponent(txt)}`
        window.location.href = `sms:${this.deviceInfo.sim}?body=${encodeURIComponent(txt)}`
      } else {
        window.location.href = `sms:${this.deviceInfo.sim}?body=${encodeURIComponent(txt)}`
      }
    },
    async loadDetail() {
      if (Vue.prototype.$functions.getDeviceInfo(this.selectedImei) === null) return
      Vue.prototype.$functions.setMobileSelectedDevices([this.selectedImei])
      this.deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedImei)

      if (this.deviceInfo.serverInfo) {
        const coords = Vue.prototype.$functions.getLatLngFromServerInfo(this.deviceInfo.serverInfo)
        if (coords) {
          this.address = await Vue.prototype.$functions.getFullAddress({
            latitude: coords.lat,
            longitude: coords.lng,
          }, this.selectedImei)
        }
      }
    },
    onSendCommand(imei, commandName) {
      // Validation
      if (!imei) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('Error'),
            text: 'IMEI دستگاه یافت نشد',
            icon: 'XIcon',
            variant: 'danger',
            dir: Vue.prototype.$functions.currentLangDirection(),
          },
        })
        return
      }

      if (!commandName || commandName.trim() === '') {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('Error'),
            text: 'دستور نمی‌تواند خالی باشد',
            icon: 'XIcon',
            variant: 'danger',
            dir: Vue.prototype.$functions.currentLangDirection(),
          },
        })
        return
      }

      // ارسال و نشان دادنِ نتیجهٔ واقعیِ دستگاه (mixins/deviceCommand)
      this.sendDeviceCommand(imei, commandName)
    },
  },
}
</script>
<style>

.theme--light.v-pagination .v-pagination__item--active{
  font-weight: bold;
  color: #2077ff;
}

[dir=rtl] .titleSpan{
  color: #222;
  padding-right: 5px;
}
[dir] .commandTabs .v-card__text{
  padding: 10px 10px 10px 10px;
}
[dir] .commandTabs .v-tab{
  padding: 0 10px 0 10px;
}
.v-tabs--vertical > .v-tabs-bar .v-tabs-bar__content{
  background: #eee;
}
.v-tab--active{
  background: #fff;
}
[dir] .commandTabs{
  border-top: 1px solid #eee;
}
[dir] .v-input--selection-controls__input + .v-label{
  font-size: 10px;
}
.v-tab {
  justify-content: flex-start;
}
[dir=ltr] .v-input {
  text-align: left;
}
.v-select__selections{
  margin-top: 20px;
}
.v-label{
  margin-right: -10px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 16px;
}

/* Loading animation */
@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.loading-container p {
  animation: pulse 2s infinite;
}
</style>
